import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  getTimesheetDetails,
  listTimesheets,
  updateTimesheet,
} from "../redux/actions/timesheetActions";
import { fetchRelationships } from "../redux/actions/relationshipActions";
import { fetchFiles } from "../redux/actions/fileActions";
import FileAutocomplete from "../components/FileAutocomplete";
import {
  Container,
  Card,
  CardContent,
  Stack,
  Breadcrumbs,
  Link,
  Autocomplete,
  FormControl,
  Box,
  Grid,
  MenuItem,
  InputAdornment,
  Select,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Divider,
  Snackbar,
  Alert,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { textFieldStyles } from "../styles/textFieldStyles";
import CustomAutocomplete from "../components/CustomAutocomplete";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { DatePicker } from "@mui/x-date-pickers";
import BreadcrumbNav from "../components/BreadcrumbNav";
import CancelButton from "../components/CancelButton";
import SubmitButton from "../components/SubmitButton";
import CustomDatePicker from "../components/CustomDatePicker";

import { useLocation } from "react-router-dom";
import { windowsTableStyles } from "../styles/windowsTableStyles";

const tableStyles = windowsTableStyles();

const EditTimesheetPage = () => {
  const { t } = useTranslation(['pages', 'forms', 'buttons', 'common']);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const location = useLocation();
  // Updated activity types
  const activityTypes = [
    { label: "COCL - Correspondentie aan/van cliënt" },
    { label: "COVE - Correspondentie aan/van verzekeraar" },
    { label: "COSC - Correspondentie aan/van schaderegelaar" },
    { label: "COTE - Correspondentie aan/van (advocaat) tegenpartij" },
    { label: "COON - Correspondentie aan/van (toedrachts)onderzoeker" },
    { label: "COWE - Correspondentie aan/van werkgever" },
    { label: "COEX - Correspondentie aan/van (schade)expert" },
    { label: "COFT - Correspondentie aan/van fysiotherapeut" },
    { label: "COPO - Correspondentie aan/van Politie / OM" },
    { label: "COFI - Correspondentie aan/van (financieel) deskundige" },
    { label: "COAR - Correspondentie aan/van arbeidsdeskundige" },
    { label: "COAI - Correspondentie aan/van arbeidsinspectie" },
    { label: "COBE - Correspondentie aan/van bestuursorgaan" },
    { label: "COBO - Correspondentie aan/van boekhouder" },
    { label: "COMATGP - Correspondentie aan/van medisch adviseur tegenpartij" },
    { label: "COMA - Correspondentie aan/van medisch adviseur" },
    { label: "COZO - Correspondentie aan/van zorgverzekeraar" },
    { label: "CODE - Correspondentie aan/van derde" },
    { label: "COHU - Correspondentie aan/van huisarts" },
    { label: "COZIE - Correspondentie aan/van ziekenhuis" },
    { label: "COPS - Correspondentie aan/van psycholoog" },
    { label: "CORE - Correspondentie aan/van revalidatiearts" },
    { label: "COVER - Correspondentie aan/van verpleeghuis" },
    { label: "COBED - Correspondentie aan/van bedrijfsarts" },
    { label: "COOR - Correspondentie aan/van orthopeed" },
    { label: "COER - Correspondentie aan/van ergotherapeut" },
    { label: "COTA - Correspondentie aan/van tandarts" },
    { label: "COG - Correspondentie aan/van gemeente" },
    { label: "COU - Correspondentie aan/van UWV" },
    { label: "CORE - Correspondentie aan/van rechterlijke macht" },
    { label: "CODE - Correspondentie aan/van deurwaarder" },
    { label: "TECL - Telefoongesprek met cliënt" },
    { label: "TEMA - Telefoongesprek met medisch adviseur" },
    { label: "TETE - Telefoongesprek met (advocaat) tegenpartij" },
    { label: "TEMATGP - Telefoongesprek met medisch adviseur tegenpartij" },
    { label: "TEUW - Telefoongesprek met UWV" },
    { label: "TEGE - Telefoongesprek met gemeente" },
    { label: "TEZIE - Telefoongesprek met ziekenhuis" },
    { label: "TEDE - Telefoongesprek met derde" },
    { label: "TEARINS - Telefoongesprek met arbeidsinspectie" },
    { label: "TEHU - Telefoongesprek met huisarts" },
    { label: "TEREVA - Telefoongesprek met revalidatiearts" },
    { label: "TEPSY - Telefoongesprek met psycholoog" },
    { label: "TESC - Telefoongesprek met schaderegelaar" },
    { label: "TEZO - Telefoongesprek met zorgverzekeraar" },
    { label: "TEBOE - Telefoongesprek met boekhouder" },
    { label: "TEERG - Telefoongesprek met ergotherapeut" },
    { label: "TEPO - Telefoongesprek met Politie / OM" },
    { label: "TEORT - Telefoongesprek met orthopeed" },
    { label: "TEVRP - Telefoongesprek met verpleeghuis" },
    { label: "TEEX - Telefoongesprek met (schade)expert" },
    { label: "TETA - Telefoongesprek met tandarts" },
    { label: "TEFYS - Telefoongesprek met fysiotherapeut" },
    { label: "TEWE - Telefoongesprek met werkgever" },
    { label: "TEBED - Telefoongesprek met bedrijfsarts" },
    { label: "TEOND - Telefoongesprek met (toedrachts)onderzoeker" },
    { label: "TEBE - Telefoongesprek met bestuursorgaan" },
    { label: "TEVE - Telefoongesprek met verzekeraar" },
    { label: "TEFI - Telefoongesprek met financieel deskundige" },
    { label: "TEARDE - Telefoongesprek met arbeidsdeskundige" },
    { label: "TERE - Telefoongesprek met rechterlijke macht" },
    { label: "TEDWR - Telefoongesprek met deurwaarder" },
    { label: "TERDW - Telefoongesprek met RDW" },
    { label: "BEKA - Bespreking met cliënt op kantoor" },
    { label: "BELO - Bespreking bij cliënt op locatie" },
    { label: "GEBECL - Gezamenlijk bezoek bij cliënt" },
    { label: "GEBEKA - Gezamenlijk bezoek op kantoor" },
    { label: "BECLE - Bespreking met cliënt elders" },
    { label: "BEDEE - Bespreking met derde elders" },
    { label: "BEDEKA - Bespreking met derde op kantoor" },
    { label: "VOBE - Voorbereiding van bespreking" },
    { label: "STUDLI - Studie literatuur en jurisprudentie" },
    { label: "STUO - Studie ontvangen stuk(ken)" },
    { label: "STUPRO - Studie ontvangen processtuk" },
    { label: "STUDIEDOS - Studie dossier" },
    { label: "DAG - (Ontwerp) dagvaarding" },
    { label: "VERZ - (Ontwerp) verzoek- of beroepschrift" },
    { label: "CONCL - (Ontwerp) conclusie, memorie, akte, verweerschrift" },
    { label: "PLEITNOTA - (Ontwerp) pleitnota" },
    { label: "OVK - (Ontwerp) overeenkomst" },
    { label: "PRODUC - Verzamelen / concipiëren bewijsstukken / producties" },
    { label: "VOORBER - (Voorbereiding) andere verrichtingen in rechte" },
    { label: "PLEID - Pleidooi / mondelinge behandeling" },
    { label: "ENQU - Bijwonen enquete" },
    { label: "COMP - Bijwonen comparitie" },
    { label: "ZITTING - Bijwonen (hoor)zitting" },
    { label: "BEZICHT - Bezichtiging ter plaatse" },
    { label: "REISCL - Reizen voor cliënt" },
    { label: "REISA - Reizen algemeen" },
    { label: "DIV - Diverse werkzaamheden" },
    { label: "FEITOND - (Feiten) onderzoek (internet, KvK, e.d.)" },
    { label: "OPPV - Opvragen proces-verbaal" },
    { label: "SCHADE - Opstellen schadestaat" },
    { label: "ALG - Algemeen" },
  ];

  const files = useSelector((state) => state.fileList.files);
  const relationships = useSelector(
    (state) => state.relationshipList.relationships
  );
  const timesheet = useSelector((state) => state.timesheetDetails.timesheet);
  
  const [formData, setFormData] = useState({
    owner: "",
    type: "",
    description: "",
    date: new Date(),
    case: "",
  });
  
  const [totalDuration, setTotalDuration] = useState(0);

  const [totalDurationDisplay, setTotalDurationDisplay] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [billingItems, setBillingItems] = useState([
    {
      type: "working_time", // Default value
      description: "", // Default value
      rate: 0, // Default value
      quantity: "00:00:00", // Default value (initially set to 0 hours)
      billable: true, // Default value
    },
  ]);
  const billingItemTypes = [
    { value: "working_time", label: t('pages:timesheets.working_time') },
    { value: "travel_time", label: t('pages:timesheets.travel_time') },
    { value: "kilometers", label: t('pages:timesheets.kilometers') }
  ];
  const predefinedQuantities = [
    "00:00:00",
    "00:06:00",
    "00:12:00",
    "00:18:00",
    "00:24:00",
    "00:30:00",
    "00:36:00",
    "00:42:00",
    "00:48:00",
    "00:54:00",
    "01:00:00",
    "01:06:00",
    "01:12:00",
    "01:18:00",
    "01:24:00",
    "01:30:00",
    "01:36:00",
    "01:42:00",
    "01:48:00",
    "01:54:00",
    "02:00:00",
    "02:06:00",
    "02:12:00",
    "02:18:00",
    "02:24:00",
    "02:30:00",
    "02:36:00",
    "02:42:00",
    "02:48:00",
    "02:54:00",
    "03:00:00",
];

  const [breadcrumbs, setBreadcrumbs] = useState([
    { label: t('navigation:home'), href: "/" },
    { label: t('navigation:timesheets'), href: "/timesheets" },
  ]);

  useEffect(() => {
    const locationCaseId = location.state?.caseId;
    const initialCaseFile =
      files?.find((file) => file._id === locationCaseId) || null;

    if (initialCaseFile) {
      setBreadcrumbs((prevBreadcrumbs) => [
        ...prevBreadcrumbs,
        {
          label: initialCaseFile.name || t('common:case_file'),
          href: `/files/${initialCaseFile._id}/timesheets`,
        },
      ]);
    }
  }, []);

  useEffect(() => {
    dispatch(getTimesheetDetails(id));
    dispatch(fetchRelationships());
    dispatch(fetchFiles());
  }, [dispatch, id]);

  useEffect(() => {
    const durationSum = billingItems.reduce((sum, item) => {
      if (item.type !== "kilometers") {
        const [hours, minutes, seconds] = item.quantity.split(":").map(Number);
        const decimalHours = hours + minutes / 60 + seconds / 3600; // Convert to decimal hours
        return sum + decimalHours;
      }
      return sum;
    }, 0);

    // Convert decimal hours to hours, minutes, and seconds
    const totalHours = Math.floor(durationSum);
    const totalHours2Digit = Math.floor(durationSum)
      .toString()
      .padStart(2, "0");
    const totalMinutes = Math.floor((durationSum - totalHours) * 60);
    const totalSeconds = Math.round(
      ((durationSum - totalHours) * 60 - totalMinutes) * 60
    );
    const totalMinutes2Digit = Math.floor((durationSum - totalHours) * 60)
      .toString()
      .padStart(2, "0");

    const totalSeconds2Digit = Math.round(
      ((durationSum - totalHours) * 60 - totalMinutes) * 60
    )
      .toString()
      .padStart(2, "0");
    const totalDurationDigitsOnly = `${totalHours2Digit}:${totalMinutes2Digit}:${totalSeconds2Digit}`;
    const formattedDuration = `${totalHours}h: ${totalMinutes}m: ${totalSeconds}s`;
    setTotalDurationDisplay(formattedDuration);
    setTotalDuration(totalDurationDigitsOnly); // Set the total duration in hours, minutes, and seconds format

    let total = 0;
    billingItems.forEach((item) => {
      if (item.type !== "kilometers") {
        const [hours, minutes, seconds] = item.quantity.split(":").map(Number);
        const decimalHours = hours + minutes / 60 + seconds / 3600; // Convert to decimal hours
        total += decimalHours * parseFloat(item.rate);
      } else {
        const amount = parseFloat(item.quantity) * parseFloat(item.rate);
        total += amount;
      }
    });
    setTotalAmount(total.toFixed(2)); // Set the total amount with 2 decimal places
  }, [billingItems]);

  useEffect(() => {
    if (timesheet) {
      setFormData({
        owner: timesheet.owner ? timesheet.owner._id : "",
        type: timesheet.type,
        description: timesheet.description,
        date: timesheet.date ? timesheet.date.split("T")[0] : new Date().toISOString().split("T")[0],
        case: timesheet.fileCase ? timesheet.fileCase._id : "",
      });
      setBillingItems(timesheet.billingItems || []);
      setTotalDuration(timesheet.totalDuration);
      setTotalAmount(timesheet.totalAmount);
    }
  }, [timesheet, files, relationships]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBillingItemChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const updatedItems = billingItems.map((item, i) => {
      if (i === index) {
        if (
          name === "quantity" &&
          (item.type === "working_time" || item.type === "travel_time")
        ) {
          let newValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
          if (newValue.length > 4) {
            newValue =
              newValue.slice(0, 2) +
              ":" +
              newValue.slice(2, 4) +
              ":" +
              newValue.slice(4, 6);
          } else if (newValue.length > 2) {
            newValue = newValue.slice(0, 2) + ":" + newValue.slice(2, 4);
          }
          return { ...item, [name]: newValue };
        }
        return { ...item, [name]: type === "checkbox" ? checked : value };
      }
      return item;
    });
    setBillingItems(updatedItems);
  };

  const handleDeleteBillingItem = (index) => {
    const updatedItems = billingItems.filter((_, i) => i !== index);
    setBillingItems(updatedItems);
  };

  const handleAddBillingItem = () => {
    setBillingItems([
      ...billingItems,
      {
        type: "working_time", // Default value
        description: "", // Default value
        rate: 100, // Default value
        quantity: "00:00:00", // Default value
        billable: true, // Default value
      },
    ]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const hasZeroTimeItem = billingItems.some(
      (item) =>
        item.type !== "kilometers" &&
        (item.quantity === "00:00:00" || !item.quantity)
    );

    if (hasZeroTimeItem) {
      setNotification({
        open: true,
        message: t('pages:timesheets.time_zero_error'),
        severity: "error",
      });
      return;
    }


    const updatedTimesheet = {
      _id: id,
      owner: formData.owner,
      type: formData.type,
      description: formData.description,
      date: formData.date,
      case: formData.case,
      billingItems: billingItems,
      totalDuration: totalDuration,
      totalAmount: totalAmount,
    };
    dispatch(updateTimesheet(updatedTimesheet));
    dispatch(fetchFiles());
    dispatch(listTimesheets());
    setTimeout(() => {
      navigate(-1);
    }, 1000);
  };

  const commonTextFieldStyles = {
    "& .MuiInputBase-root": {
      border: "none",
      padding: "0 8px", // Add small padding
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)", // Light grey background on hover
      },
    },
    "& .MuiInputLabel-root": {
      "&:hover": {
        color: "primary.main", // Change label color on hover
      },
    },
  };
  const handleCancel = () => {
    navigate("/timesheets");
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };
  const inputStyles = { width: "100%", marginBottom: 2 };
  const buttonStyles = { margin: "0 8px" };

  const isEditable = timesheet && !timesheet.status;

  return (
    <Container
      maxWidth="lg"
      style={{ position: "relative", paddingBottom: "80px" }}
    >
      <BreadcrumbNav
        title={t('pages:timesheets.edit_title')}
        breadcrumbs={breadcrumbs}
        showBreadcrumbs={true}
      />
      ,
      {timesheet && timesheet.status === "status" && (
        <p>{t('pages:timesheets.cannot_edit_billed')}</p>
      )}
      <Box
        sx={{
          backgroundColor: "white",
          padding: "30px 24px",
          marginTop: "24px",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FormControl variant="standard" sx={{ mr: 3, width: "100%" }}>
                <CustomAutocomplete
                  options={relationships}
                  value={
                    relationships?.find((rel) => rel._id === formData.owner) ||
                    null
                  }
                  onChange={(event, newValue) =>
                    handleChange({
                      target: {
                        name: "owner",
                        value: newValue ? newValue._id : "",
                      },
                    })
                  }
                  label={t('common:owner')}
                  filterType="Member"
                  addNewLabel={t('pages:timesheets.add_owner')}
                  addNewPath="/relationships/create"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                options={activityTypes}
                getOptionLabel={(option) => option.label}
                value={
                  activityTypes.find((type) => type.label === formData.type) ||
                  null
                }
                onChange={(event, newValue) =>
                  handleChange({
                    target: {
                      name: "type",
                      value: newValue ? newValue.label : "",
                    },
                  })
                }
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t('common:type')}
                    sx={textFieldStyles()}
                    size="small"
                    // variant="outlined"
                    fullWidth
                    required
                    disabled={!isEditable}
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}>
              <Box sx={{ width: "100%" }}>
                <CustomDatePicker
                  label={t('common:date')}
                  value={formData.date}
                  onChange={(value) =>
                    handleChange({
                      target: {
                        name: "date",
                        value: value,
                      },
                    })
                  }
                  required
                  sx={{ width: "100%" }}
                />
              </Box>
            </Grid>
            <Grid item xs={4}>
              <FileAutocomplete
                options={files}
                value={files.find((file) => file._id === formData.case) || null}
                onChange={(event, newValue) =>
                  handleChange({
                    target: {
                      name: "case",
                      value: newValue ? newValue._id : "",
                    },
                  })
                }
                label={t('common:case')}
                name="case"
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                label={t('common:description')}
                name="description"
                value={formData.description}
                onChange={handleChange}
                multiline
                fullWidth
                sx={textFieldStyles()}
                size="small"
                // variant="outlined"
                disabled={!isEditable}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div>
              <Box sx={{ marginTop: 2 }}>
                <Typography variant="h6" sx={tableStyles.typography}>
                  {t('pages:timesheets.billing_items')}
                </Typography>
              </Box>

              <TableContainer component={Paper} sx={tableStyles.container}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={tableStyles.headerCell}>{t('common:type')}</TableCell>
                      <TableCell sx={tableStyles.headerCell}>{t('common:rate')}</TableCell>
                      <TableCell
                        sx={{
                          ...tableStyles.headerCell,
                          width: "200px",
                        }}
                      >
                        {t('common:quantity')}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          ...tableStyles.headerCell,
                          width: "100px",
                        }}
                      >
                        {t('common:status')}
                      </TableCell> */}
                      <TableCell
                        sx={{
                          ...tableStyles.headerCell,
                          width: "100px",
                        }}
                      >
                        {t('common:amount')}
                      </TableCell>
                      <TableCell sx={tableStyles.headerCell}>{t('common:actions')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {billingItems.map((item, index) => (
                      <TableRow key={index} sx={tableStyles.row}>
                        <TableCell sx={tableStyles.cell}>
                          <TextField
                            select
                            variant="standard"
                            name="type"
                            value={item.type}
                            required
                            onChange={(e) => {
                              handleBillingItemChange(index, e);
                              // Update quantity based on type
                              const newQuantity =
                                e.target.value === "kilometers"
                                  ? "0"
                                  : "00:00:00";
                              const updatedItems = [...billingItems];
                              updatedItems[index] = {
                                ...updatedItems[index],
                                type: e.target.value,
                                quantity: newQuantity,
                              };
                              // console.log(updatedItems);
                              setBillingItems(updatedItems);
                            }}
                            fullWidth
                            InputProps={{
                              disableUnderline: true,
                            }}
                            sx={{ ...commonTextFieldStyles, minWidth: 150 }}
                          >
                            {billingItemTypes.map((type) => (
                              <MenuItem key={type.value} value={type.value}>
                                {type.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </TableCell>
                        <TableCell sx={tableStyles.cell}>
                          <TextField
                            variant="standard"
                            name="rate"
                            type="number"
                            value={item.rate}
                            onChange={(e) => handleBillingItemChange(index, e)}
                            fullWidth
                            InputProps={{
                              disableUnderline: true,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Typography variant="body2">€</Typography>
                                </InputAdornment>
                              ),
                            }}
                            sx={commonTextFieldStyles}
                          />
                        </TableCell>
                        <TableCell sx={tableStyles.cell}>
                          <TextField
                            variant="standard"
                            name="quantity"
                            value={item.quantity}
                            onChange={(e) => handleBillingItemChange(index, e)}
                            fullWidth
                            InputProps={{
                              disableUnderline: true,
                              endAdornment:
                                item.type !== "kilometers" ? (
                                  <InputAdornment position="end">
                                    <Select
                                      value=""
                                      onChange={(e) =>
                                        handleBillingItemChange(index, {
                                          target: {
                                            name: "quantity",
                                            value: e.target.value,
                                          },
                                        })
                                      }
                                      displayEmpty
                                      IconComponent={ArrowDropDownIcon}
                                      sx={{
                                        "& .MuiSelect-select": {
                                          padding: 0,
                                          display: "flex",
                                          alignItems: "center",
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          border: "none",
                                        },
                                        "& .MuiPaper-root": {
                                          width: "100%",
                                        },
                                      }}
                                      MenuProps={{
                                        PaperProps: {
                                          sx: {
                                            maxHeight: 200, // Set the maximum height for the dropdown menu
                                            overflowY: 'auto', // Enable vertical scrolling
                                            "&::-webkit-scrollbar": {
                                              width: "8px", // Decrease the width of the scrollbar
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                              backgroundColor: "#888", // Color of the scrollbar thumb
                                              borderRadius: "4px", // Rounded corners for the scrollbar thumb
                                            },
                                            "&::-webkit-scrollbar-thumb:hover": {
                                              backgroundColor: "#555", // Color of the scrollbar thumb on hover
                                            },
                                          },
                                        },
                                      }}
                                    >
                                      {predefinedQuantities.map((quantity) => (
                                        <MenuItem
                                          key={quantity}
                                          value={quantity}
                                        >
                                          {quantity}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </InputAdornment>
                                ) : null,
                            }}
                            placeholder={
                              item.type === "kilometers"
                                ? "0 Kilometers"
                                : "hh:mm"
                            }
                            sx={commonTextFieldStyles}
                          />
                        </TableCell>
                        {/* <TableCell sx={tableStyles.cell}>
                          <FormGroup>
                            <FormControlLabel
                              label={t('common:billable')}
                              control={
                                <Checkbox
                                  name="billable"
                                  checked={item.billable}
                                  onChange={(e) =>
                                    handleBillingItemChange(index, e)
                                  }
                                />
                              }
                            />
                          </FormGroup>
                        </TableCell> */}

                        <TableCell sx={tableStyles.cell}>
                          <Typography>
                            €{" "}
                            {item.type !== "kilometers"
                              ? (
                                  parseFloat(item.rate) *
                                  (parseInt(item.quantity.split(":")[0]) + // Hours
                                    parseInt(item.quantity.split(":")[1]) / 60 + // Minutes
                                    parseInt(item.quantity.split(":")[2]) /
                                      3600)
                                ) // Seconds
                                .toFixed(2)
                                .toString()
                                .replace(".", ",") // Replace decimal point with a comma
                              : (parseFloat(item.rate) *
                                  parseFloat(item.quantity) || 0)
                                  .toFixed(2)
                                  .toString()
                                  .replace(".", ",") // Replace decimal point with a comma
                                  }
                          </Typography>
                        </TableCell>
                        <TableCell sx={tableStyles.cell}>
                          <IconButton
                            onClick={() => handleDeleteBillingItem(index)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <Button
              variant="text"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleAddBillingItem}
              sx={{ marginTop: 2, textTransform: "none" }}
            >
              {t('pages:timesheets.add_billing_item')}
            </Button>
          </Grid>
          <Divider sx={{ my: 3 }} />
          <Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                <Card
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "5px",
                    boxShadow: "none",
                    border: "none",
                  }}
                  elevation={0}
                >
                  <CardContent sx={{ padding: "8px" }}>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      sx={{ fontWeight: "bold" }}
                    >
                      {t('pages:timesheets.total_duration')}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontSize: "1.2rem" }}
                    >
                      {totalDurationDisplay}
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "5px",
                    boxShadow: "none",
                    border: "none",
                  }}
                  elevation={0}
                >
                  <CardContent sx={{ padding: "8px" }}>
                    <Typography
                      variant="subtitle1"
                      component="div"
                      sx={{ fontWeight: "bold" }}
                    >
                      {t('pages:timesheets.total_amount')}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontSize: "1.2rem" }}
                    >
                      € {totalAmount?.toString().replace(".", ",")}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              // padding: "10px 16px",
              // background: "#fff",
              zIndex: 10,
              backgroundColor: "white",
              fontFamily: "'Segoe UI', sans-serif",
              fontSize: "18px",
              fontWeight: 500,
              color: "#000000",
              padding: "13px 80px",
            }}
          >
            <CancelButton
              variant="outlined"
              onClick={handleCancel}
              size="small"
            >
              {t('buttons:cancel')}
            </CancelButton>
            <SubmitButton onClick={handleSubmit} size="small">
              {t('pages:timesheets.save_timesheet')}
            </SubmitButton>
          </Box>
        </form>
      </Box>
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default EditTimesheetPage;
